/* Octa Pearl quick view: opens a product in a popup from any card button with [data-lgq="handle"]. */
(function () {
  'use strict';
  if (window.lgQuickView) return;
  window.lgQuickView = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var dlg, state;

  function money(c) {
    var fmt = window.money_format || '${{amount}}';
    var v = c / 100;
    var w = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return String(fmt).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toLocaleString('en-US')).replace(/\{\{\s*amount\w*\s*\}\}/, w).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function nice(v) { return String(v || '').toLowerCase().replace(/(^|\s)(\S)/g, function (m, s, c) { return s + c.toUpperCase(); }).replace(/(\d+)k\b/g, '$1K'); }
  function isRing(p) {
    var t = ((p.type || '') + ' ' + (p.title || '')).toLowerCase();
    if (/earring|necklace|pendant|bracelet|bangle|anklet|brooch|cufflink/.test(t)) return false;
    return /\brings?\b|\bbands?\b/.test(t);
  }
  function toneOf(src, alt) {
    var a = (alt || '').toLowerCase();
    if (/\brose\b/.test(a)) return 'rose';
    if (/\byellow\b/.test(a)) return 'yellow';
    if (/\bwhite\b|platinum/.test(a)) return 'white';
    var f = (src || '').split('?')[0].split('/').pop().toLowerCase();
    var m = f.match(/[-_]([ywr])\d{1,2}(?:[-_.]|$)/);
    return m ? { y: 'yellow', w: 'white', r: 'rose' }[m[1]] : null;
  }
  function img(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var ICON = {
    x: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    p: '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>',
    n: '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'lgq';
    dlg.setAttribute('aria-label', 'Quick view');
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('lgq-lock');
      if (history.state && history.state.lgq) { state.fromPop = true; history.back(); }
      if (state && state.opener) state.opener.focus({ preventScroll: true });
    });
    dlg.addEventListener('cancel', function () { /* Esc: let the dialog close normally */ });
    window.addEventListener('popstate', function () { if (dlg.open) dlg.close(); });
    document.body.appendChild(dlg);
  }

  function open(handle, opener) {
    if (!dlg) build();
    state = { opener: opener };
    dlg.innerHTML = '<div class="lgq__handle" aria-hidden="true"></div><button type="button" class="lgq__x" aria-label="Close">' + ICON.x + '</button><div class="lgq__loading">Loading…</div>';
    dlg.querySelector('.lgq__x').onclick = function () { dlg.close(); };
    if (!dlg.open) {
      dlg.showModal();
      try { history.pushState({ lgq: 1 }, ''); } catch (e) {}
    }
    document.documentElement.classList.add('lgq-lock');
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (p) { render(p); })
      .catch(function () { window.location.href = root + 'products/' + handle; });
  }

  function render(p) {
    var media = (p.media || []).filter(function (m) { return m.media_type === 'image' || m.preview_image; }).map(function (m) {
      var src = m.src || (m.preview_image && m.preview_image.src); return { src: src, alt: m.alt || p.title, tone: toneOf(src, m.alt) };
    });
    if (!media.length) media = (p.images || []).map(function (s) { return { src: s, alt: p.title, tone: toneOf(s, '') }; });
    var opts = (p.options || []).map(function (o, i) { return { name: typeof o === 'string' ? o : o.name, values: o.values || [], i: i }; });
    var hasColorOpt = opts.some(function (o) { return /colou?r/i.test(o.name); });
    var tones = ['yellow', 'white', 'rose'].filter(function (t) { return media.some(function (m) { return m.tone === t; }); });
    var ring = isRing(p);
    var v0 = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    state.p = p; state.media = media; state.ring = ring; state.sel = v0.options.slice();
    state.tone = (tones.length > 1 && !hasColorOpt) ? (media[0] && media[0].tone && tones.indexOf(media[0].tone) > -1 ? media[0].tone : tones[0]) : null;
    state.tones = (tones.length > 1 && !hasColorOpt) ? tones : [];

    var h = '<div class="lgq__handle" aria-hidden="true"></div><button type="button" class="lgq__x" aria-label="Close">' + ICON.x + '</button><div class="lgq__grid">';
    h += '<div class="lgq__gal"><div class="lgq__main"><div class="lgq__track" data-lgq-track tabindex="0" aria-label="Product photos"></div><button type="button" class="lgq__nav lgq__nav--p" aria-label="Previous photo" data-lgq-prev>' + ICON.p + '</button><button type="button" class="lgq__nav lgq__nav--n" aria-label="Next photo" data-lgq-next>' + ICON.n + '</button><div class="lgq__dots" data-lgq-dots aria-hidden="true"></div></div><div class="lgq__thumbs" data-lgq-thumbs></div></div>';
    h += '<div class="lgq__info"><h2 class="lgq__title">' + esc(p.title) + '</h2><div class="lgq__pricerow"><p class="lgq__price" data-lgq-price></p><a class="lgq__full lgq__full--top" href="' + esc(p.url) + '">View full details</a></div>';
    opts.forEach(function (o) {
      if (o.values.length < 2 && !/metal/i.test(o.name)) return;
      var label = /metal|material/i.test(o.name) && !/colou?r/i.test(o.name) ? 'Metal' : nice(o.name);
      h += '<div class="lgq__opt"><span class="lgq__label">' + esc(label) + ': <span data-lgq-chosen="' + o.i + '"></span></span><div class="lgq__vals">';
      o.values.forEach(function (val) { h += '<button type="button" class="lgq__pill" data-lgq-opt="' + o.i + '" data-val="' + esc(val) + '">' + esc(nice(val)) + '</button>'; });
      h += '</div></div>';
    });
    if (state.tones.length) {
      h += '<div class="lgq__opt"><span class="lgq__label">Metal color: <span data-lgq-tone-chosen></span></span><div class="lgq__vals">';
      state.tones.forEach(function (t) { h += '<button type="button" class="lgq__sw lgq__sw--' + t + '" data-lgq-tone="' + t + '"><i aria-hidden="true"></i>' + nice(t) + '</button>'; });
      h += '</div></div>';
    }
    if (ring) {
      h += '<div class="lgq__opt" data-lgq-sizewrap><div class="lgq__row"><label class="lgq__label" for="lgq-size">Ring size</label><a href="' + root + 'pages/ring-size-guide" target="_blank" rel="noopener">Find your size</a></div><div class="lgq__select"><select id="lgq-size" data-lgq-size><option value="">Select your ring size</option>';
      for (var s = 3; s <= 12.75; s += 0.25) h += '<option value="' + s + '">' + s + '</option>';
      h += '<option value="Not sure - contact me">Not sure — please contact me</option></select></div><p class="lgq__err" data-lgq-err hidden>Please choose your ring size.</p></div>';
    }
    h += '<div class="lgq__buy"><p class="lgq__msg" data-lgq-msg hidden></p><div class="lgq__buyrow"><span class="lgq__buyprice" data-lgq-buyprice></span><button type="button" class="lgq__add" data-lgq-add>Add to bag</button></div></div>';
    var d = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    if (d) h += '<p class="lgq__desc">' + esc(d) + '</p>';
    h += '<ul class="lgq__facts"><li>Made to order for you</li><li>Free insured US shipping</li><li>30-day returns on ready-made designs</li></ul>';
    h += '</div></div>';
    dlg.innerHTML = h;
    dlg.setAttribute('aria-label', 'Quick view: ' + p.title);
    dlg.querySelector('.lgq__x').onclick = function () { dlg.close(); };
    dlg.querySelectorAll('[data-lgq-opt]').forEach(function (b) {
      b.onclick = function () { state.sel[+b.dataset.lgqOpt] = b.dataset.val; pickClosest(+b.dataset.lgqOpt); update(); };
    });
    dlg.querySelectorAll('[data-lgq-tone]').forEach(function (b) {
      b.onclick = function () { if (b.disabled) return; state.tone = b.dataset.lgqTone; state.idx = 0; state.photoKey = null; update(); };
    });
    dlg.querySelector('[data-lgq-prev]').onclick = function () { step(-1); };
    dlg.querySelector('[data-lgq-next]').onclick = function () { step(1); };
    var size = dlg.querySelector('[data-lgq-size]');
    if (size) size.onchange = function () { showErr(false); };
    dlg.querySelector('[data-lgq-add]').onclick = add;
    state.idx = 0;
    update();
    var first = dlg.querySelector('.lgq__pill, [data-lgq-add]'); if (first) first.focus({ preventScroll: true });
  }

  function current() { return state.p.variants.find(function (v) { return v.options.every(function (o, i) { return o === state.sel[i]; }); }); }
  function pickClosest(i) {
    var v = current();
    if (v && v.available) return;
    var mine = state.sel[i];
    v = state.p.variants.find(function (x) { return x.available && x.options[i] === mine; }) || state.p.variants.find(function (x) { return x.options[i] === mine; });
    if (v) state.sel = v.options.slice();
  }
  function plat() { return state.sel.some(function (o) { return /platinum/i.test(o); }); }
  function photos() {
    if (!state.tones.length) return state.media;
    var t = plat() ? 'white' : state.tone;
    var list = state.media.filter(function (m) { return !m.tone || m.tone === t; });
    return list.length ? list : state.media;
  }
  function step(n) { var l = photos(); go((state.idx + n + l.length) % l.length, true); }
  function go(i, smooth) {
    var tr = dlg.querySelector('[data-lgq-track]'); if (!tr) return;
    state.idx = i;
    tr.scrollTo({ left: i * tr.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    mark();
  }
  function mark() {
    dlg.querySelectorAll('[data-lgq-thumbs] button').forEach(function (b, i) { b.classList.toggle('is-on', i === state.idx); });
    dlg.querySelectorAll('[data-lgq-dots] i').forEach(function (d, i) { d.classList.toggle('is-on', i === state.idx); });
  }
  function showPhoto() {
    var l = photos(), tr = dlg.querySelector('[data-lgq-track]');
    var key = l.map(function (x) { return x.src; }).join('|');
    if (state.photoKey !== key) {
      state.photoKey = key;
      tr.innerHTML = l.map(function (x, i) {
        return '<div class="lgq__slide"><img src="' + esc(img(x.src, 900)) + '" srcset="' + esc(img(x.src, 600)) + ' 600w, ' + esc(img(x.src, 900)) + ' 900w, ' + esc(img(x.src, 1200)) + ' 1200w" sizes="(max-width: 749px) 100vw, 520px" alt="' + esc(x.alt) + '"' + (i ? ' loading="lazy"' : '') + '></div>';
      }).join('');
      var th = dlg.querySelector('[data-lgq-thumbs]');
      th.innerHTML = l.map(function (x, i) { return '<button type="button" aria-label="Photo ' + (i + 1) + '" data-i="' + i + '"><img src="' + esc(img(x.src, 160)) + '" alt="" loading="lazy"></button>'; }).join('');
      th.querySelectorAll('button').forEach(function (b) { b.onclick = function () { go(+b.dataset.i, true); }; });
      dlg.querySelector('[data-lgq-dots]').innerHTML = l.length > 1 ? l.map(function () { return '<i></i>'; }).join('') : '';
      var nav = l.length > 1 ? '' : 'none';
      dlg.querySelector('[data-lgq-prev]').style.display = nav; dlg.querySelector('[data-lgq-next]').style.display = nav;
      if (state.idx >= l.length) state.idx = 0;
      requestAnimationFrame(function () { go(state.idx, false); });
      if (!tr.dataset.bound) {
        tr.dataset.bound = '1';
        var t; tr.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { state.idx = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); mark(); }, 60); }, { passive: true });
      }
    } else { mark(); }
  }
  function update() {
    var v = current(), p = state.p;
    dlg.querySelectorAll('[data-lgq-opt]').forEach(function (b) {
      var i = +b.dataset.lgqOpt, on = state.sel[i] === b.dataset.val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      var test = state.sel.slice(); test[i] = b.dataset.val;
      var x = p.variants.find(function (y) { return y.options.every(function (o, j) { return o === test[j]; }); });
      b.disabled = !x || !x.available;
    });
    dlg.querySelectorAll('[data-lgq-chosen]').forEach(function (s) { s.textContent = nice(state.sel[+s.dataset.lgqChosen]); });
    if (state.tones.length) {
      var pl = plat();
      dlg.querySelectorAll('[data-lgq-tone]').forEach(function (b) {
        var t = b.dataset.lgqTone; b.disabled = pl && t !== 'white';
        var on = pl ? t === 'white' : t === state.tone; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
      dlg.querySelector('[data-lgq-tone-chosen]').textContent = pl ? 'White (Platinum)' : nice(state.tone) + ' Gold';
    }
    var pr = dlg.querySelector('[data-lgq-price]');
    if (v) pr.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
    var bp = dlg.querySelector('[data-lgq-buyprice]'); if (bp && v) bp.textContent = money(v.price);
    var addB = dlg.querySelector('[data-lgq-add]');
    addB.disabled = !v || !v.available; addB.textContent = v && v.available ? 'Add to bag' : 'Sold out';
    showPhoto();
  }
  function showErr(on) {
    var w = dlg.querySelector('[data-lgq-sizewrap]'); if (!w) return;
    w.classList.toggle('has-err', on); dlg.querySelector('[data-lgq-err]').hidden = !on;
  }
  function add() {
    var v = current(), btn = dlg.querySelector('[data-lgq-add]'), msg = dlg.querySelector('[data-lgq-msg]');
    if (!v || !v.available) return;
    var props = {}, size = dlg.querySelector('[data-lgq-size]');
    if (size) { if (!size.value) { showErr(true); size.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { size.focus({ preventScroll: true }); }, 350); return; } props['Ring size'] = size.value; }
    if (state.tones.length) props['Metal color'] = plat() ? 'White (Platinum)' : nice(state.tone) + ' Gold';
    btn.classList.add('is-busy'); msg.hidden = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.ajax-cart-count').forEach(function (el) { var s = el.querySelector('span') || el; s.textContent = cart.item_count; el.classList.toggle('is-zero', !cart.item_count); });
        msg.innerHTML = 'Added to your bag. <a href="' + root + 'cart">View bag</a> · <a href="' + root + 'checkout">Checkout</a>';
        msg.hidden = false;
      })
      .catch(function (e) { msg.textContent = e.message; msg.hidden = false; })
      .finally(function () { btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lgq]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); e.stopPropagation();
    open(a.getAttribute('data-lgq'), a);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!dlg || !dlg.open || /SELECT|INPUT|TEXTAREA/.test(e.target.tagName)) return;
    if (e.key === 'ArrowLeft') step(-1); else if (e.key === 'ArrowRight') step(1);
  });
})();
